<template>
    <div class="topic-detail">
        <short-video-list-skeleton v-if="loading"></short-video-list-skeleton>

        <div class="list" :style="'min-height:100vh;background-image: url('+topic.footer_img+')'" v-else>

            <div class="title" style="opacity: 0">
                <img :src="topic.logo" class="logo" alt/>
                <div :style="'color:'+topic.title_color+';font-size:'+topic.title_font_size">{{ topic.title }}</div>
            </div>
            <div class="clearfix"></div>

            <div class="topic-detail-content" :style="topic.id == 39 ? 'margin-bottom:20%':''">
                <div class="swipe topic-detail-content-img">
                    <van-swipe :autoplay="3000" indicator-color="#fff" touchable ref="swipe">
                        <van-swipe-item v-for="(item,i) in banners" :key="i">
                            <a :href="item.target_url.replace('https://byh.dr-gobroad.com','https://byh.dr-gobroad.com')">
                                <img :src="item.img" alt/>
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <div class="topic-detail-content-text" v-if="topic.desc.length > 0">
                    <div class="topic-detail-content-name" v-if="topic.show_desc_title==1">{{ topic.desc_title }}</div>
                    <div :class="'topic-detail-content-text-box '+all">
                        {{topic.desc.length > 66 ? topic.desc.substr(0,66)+'...' : topic.desc}}
                        <div class="more" @click="goDesc">
                            更多
                            <img src="/static/img/naxin/icon_more.svg" alt/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dynamic" v-if="topic.news && topic.news.length > 0">
                <div class="dynamic-title">{{ topic.news_title }}</div>
                <div class="more" @click="$router.push({name: 'topic-news-list',params: {id: $route.params.id}})">
                    更多
                    <img src="/static/img/naxin/icon_more.svg" alt/>
                </div>
                <div class="dynamic-box" v-for="(item,i) in topic.news" v-if="i<3" @click="goNews(item)">
                    <img class="num-img" :src="'/static/img/naxin/icon_topic_news_'+(i+1)+'.svg'" alt/>
                    <div class="dynamic-box-info">{{ item.title }}</div>
                    <img src="/static/img/naxin/icon_more.svg" alt/>
                </div>
            </div>

            <div v-if="modules.length==2 || modules.length==4" class="special-column">
                <div class="box" @click="handleHonor(item)" v-for="item in modules">
                    <div class="top">
                        <div class="top-title">{{ item.title }}</div>
                        <div class="more">更多<img src="/static/img/naxin/icon_more.svg" alt/></div>
                    </div>
                    <img class="people-img" :src="item.logo" alt/>
                    <div class="introduce">{{ item.desc }}</div>
                </div>
            </div>
            <!-- 显示一个和三个 -->
            <div v-else-if="modules.length==1 || modules.length==3" style="margin-top: 10px;">
                <div class="one-three" v-for="item in modules" @click="handleHonor(item)">
                    <div class="top">
                        <div class="top-title">{{ item.title }}</div>
                        <div class="more">
                            更多<img src="/static/img/naxin/icon_more.svg" alt/>
                        </div>
                    </div>
                    <!-- 显示两个和四个 -->
                    <div class="contents">
                        <img class="people-img" :src="item.logo" alt/>
                        <div class="text">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
            <!-- 大于四个 -->
            <div v-else-if="modules.length>4" class="greater-than">
                <div class="box" v-for="item in modules" @click="handleHonor(item)">
                    <img class="icon-img" :src="item.logo" alt/>
                    <div>{{ item.title }}</div>
                </div>
            </div>
            <!-- 合作平台 -->
            <div class="cooperation" v-if="topic.media_title && topic.cooperates && topic.cooperates.length > 0">
                <div class="name">{{ topic.media_title }}</div>
                <div class="ad">
                    <div class="swiper-slide">
                        <img class="ad_logo" v-for="item in topic.cooperates" :src="item.logo" alt/>
                    </div>
                </div>
            </div>
            <!-- 联系我们 -->
            <div class="contact" v-if="topic.contact_title && ( mobile.length > 0 || topic.email != '' || topic.qrcode_name != '' || topic.qrcode != '')">
                <div class="name">{{ topic.contact_title }}</div>
                <div class="info" v-if="mobile.length > 0" v-for="item in mobile">
                    <span>{{ item }}</span>
                </div>
                <div class="info" v-if="topic.email!=''">
                    邮箱：
                    <span>{{ topic.email }}</span>
                </div>
                <div class="info" v-if="topic.qrcode_name != ''">
                    联系小助手：
                    <span>{{ topic.qrcode_name }}</span>
                </div>
                <img class="qr-code" v-if="topic.qrcode != ''" :src="topic.qrcode" alt/>
            </div>
        </div>
        <Back bottom="14vh"></Back>
    </div>
</template>

<script>
import Interface from "@/util/interface"
import shortVideoListSkeleton from "@/skeleton/shortVideoListSkeleton"
import Back from '@/components/back'

export default {
    components: {
        'short-video-list-skeleton': shortVideoListSkeleton,
        Back,
    },
    data() {
        return {
            banners: [],
            id: 0,
            activeTab: 0,
            showNum: 4,
            value: '',
            topic: {
                footer_img: ""
            },
            loading: true,
            modules: [],
            all: false,
            mobile: [],
            contact_title:"",
            media_title:"",
            links:[],
        }
    },
    methods: {
        handleHonor(item) {
            if (item.link && item.link != "") {
                window.location.href = item.link
                return;
            }

            if (item.id  == 35){
                this.$router.push({
                    name : "topic-detail",
                    params : {
                        id : 8
                    },
                })
                return
            }else if (item.id  == 36){
                this.$router.push({
                    name : "topic-detail",
                    params : {
                        id : 5
                    },
                })
                return
            }else if (item.id  == 37){
                this.$router.push({
                    name : "topic-detail",
                    params : {
                        id : 6
                    },
                })
                return
            }else if (item.id  == 38){
                this.$router.push({
                    name : "topic-detail",
                    params : {
                        id : 7
                    },
                })
                return
            }

            if (item.key == 'study_group') {
                this.$router.push({
                        name: 'study-group-recruitment',
                        params: {
                            topic_id : this.id,
                            topic_subject_id : item.id
                        }
                    }
                )
            }else if(item.key == 'honorary'){
                this.$router.push({
                    name : "topic-honor",
                    params : {
                        topic_id : this.id,
                    },
                })
            }else if(item.key == 'column'){
                if(item.link != ""){
                    window.location.href = item.link
                }else{
                    this.$router.push({
                        name : "topic-column",
                        params : {
                            topic_id : this.id,
                            topic_subject_id : item.id
                        },
                    })
                }
            }else if(item.key == 'link'){
                window.location.href = item.link
            }
            if (item.id) {
                Interface.mFootPrint(item.id,46,0,0,0,item.title)
            }

        },
        fetch(scene) {
            if (scene === 'detail') {
                Interface.getData('get', Interface.topic.detail + this.id).then((res) => {
                    this.topic = res.data

                    let desc  = ""

                    switch (this.topic.id) {
                        case 2:
                            desc = "精准医疗，诊断先行"
                            break
                        case 21:
                            desc = "零门槛开展临床研究的学术交流专区"
                            break
                        case 4:
                            desc = "把脉国际学术新知"
                            break
                        default:
                            desc = this.topic.desc
                            break
                    }

                    // Interface.getShareInfo(this, this.topic.title, this.topic.cover_img, desc,13,false,{isTopic:true})
                    Interface.getShareInfo(this, this.topic.title, this.topic.cover_img, desc,13,this.id,
                        Interface.host + '/#/topic-detail/' + this.id + '?source_type=1')

                    let source_type = Interface.getUrl(window.location.href)
                    if (source_type) {
                        Interface.mFootPrint(this.id, 13,0, 0, source_type, this.topic.title)
                    } else {
                        Interface.mFootPrint(this.id, 13,0, 0, 0, this.topic.title)
                    }
                    this.loading = false

                    let column = []
                    let study_group = []
                    let honorary = []
                    this.modules = [] ;
                    let links = []
                    this.topic.modules.forEach(val => {
                        if (val.key == 'column') {
                            column.push(val)
                            this.modules.push(val)
                        } else if (val.key == 'study_group') {
                            study_group.push(val)
                            this.modules.push(val)
                        } else if (val.key == 'honorary') {
                            honorary.push(val)
                            this.modules.push(val)
                        } else if (val.key == 'link') {
                            links.push(val)
                        } else if (val.key == 'intro') {
                            this.topic.desc_title = val.title
                        } else if (val.key == 'news') {
                            this.topic.news_title = val.title
                        } else if (val.key == 'contact_us') {
                            this.topic.contact_title = val.title
                        } else if (val.key == 'media') {
                            this.topic.media_title = val.title
                        }
                    })

                    let news = []
                    if (this.topic.news && this.topic.news > 0){
                        this.topic.news.forEach(val=>{
                            if (news.length < 3){
                                news.push(val)
                            }
                        })
                        this.topic.news = news
                    }
                    // this.modules = [].concat(column, study_group, honorary,links)
                    if(this.topic.mobile != "" && this.topic.mobile != ",")
                        this.mobile = this.topic.mobile.split(",")
                    if(this.topic.banners)
                        this.banners = this.topic.banners
                    if(this.topic.news)
                        this.news = this.topic.news
                })
            }
        },
        goNews(item) {
            if (item.content_type == 1) {
                this.$router.push({
                    name: 'meeting-news-detail',
                    params: {
                        id: item.id
                    }
                })
            } else {
                location.href = item.target_url
            }
        },
        goDesc() {
            this.$router.push({
                name: 'topic-desc',
                params: {
                    id: this.id
                }
            })
        }
    },
    watch:{
        async $route(to,from){
            this.id = this.$route.params.id
            await this.fetch('detail')
            sessionStorage.removeItem("search_data")
        }
    },
    async created() {
        this.id = this.$route.params.id
        await this.fetch('detail')
        sessionStorage.removeItem("search_data")
        Interface.footPrint(18,this.id)

    },
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/topic/topic-detail/index.vue